import {apiPost} from '@api/api'
import {ApiRes} from '@type/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiReadAllNotification = async (): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost(`notifications`)
}
